import Service from './Service';
import GeneralUtils from "../utils/GeneralUtils";
import {SERVER_URL} from "../utils/Constants";

export default class PriceService extends Service {
    constructor() {
        super();
        this.baseURL = 'price';
    }

    findByProductId(productId) {
        return fetch(SERVER_URL + this.baseURL + '/findByProductId/' + productId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}